import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spinner"
export default class extends Controller {
  static targets = [ "container"]
  connect() {
    this.onBeforeVisit = this.show.bind(this)
    this.onTurboLoad = this.hide.bind(this)
    this.onSpinnerShow = this.show.bind(this)
    this.onSpinnerHide = this.hide.bind(this)
    this.onBeforeStreamRender = this.hide.bind(this)

    document.addEventListener("turbo:before-visit", this.onBeforeVisit)
    document.addEventListener("turbo:load", this.onTurboLoad)
    document.addEventListener("spinner:show", this.onSpinnerShow)
    document.addEventListener("spinner:hide", this.onSpinnerHide)
    document.addEventListener("turbo:before-stream-render", this.onBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.onBeforeVisit)
    document.removeEventListener("turbo:load", this.onTurboLoad)
    document.removeEventListener("spinner:show", this.onSpinnerShow)
    document.removeEventListener("spinner:hide", this.onSpinnerHide)
    document.removeEventListener("turbo:before-stream-render", this.onBeforeStreamRender)
  }

  show() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("d-none")
    }
  }

  hide() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("d-none")
    }
  }
}
